(function () {
	'use strict';

	function ready(fn) {
		if (document.readyState !== 'loading') fn();
		else document.addEventListener('DOMContentLoaded', fn);
	}

	ready(function () {
		if (!window.BloomSession) return;

		function emit(type, fields) {
			var ev = { type: type, event_id: window.__bsUuid(), ts: Date.now(), _unsent: true };
			for (var k in fields) ev[k] = fields[k];
			window.BloomSession.push(ev);
		}

		// Перехватываем существующий BloomSession.push, чтобы автоматически проставлять
		// event_id, ts и пометку _unsent на любое событие, идущее через старый API.
		var origPush = window.BloomSession.push;
		window.BloomSession.push = function (evt) {
			if (evt && !evt.event_id) evt.event_id = window.__bsUuid();
			if (evt && !evt.ts) evt.ts = Date.now();
			if (evt) evt._unsent = true;
			return origPush(evt);
		};

		window.__bsPing().then(function () {
			var es = window.__bsEnsureSession();
			var customer_id = document.body.dataset.customerId || null;

			if (es.fresh) {
				var utm = es.session.utm;
				emit('session_start', {
					url: location.pathname,
					referrer: document.referrer || null,
					landing_url: es.session.landing_url,
					utm_source:   utm.utm_source,
					utm_medium:   utm.utm_medium,
					utm_campaign: utm.utm_campaign,
					device:  /Mobi|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
					lang:    navigator.language,
					tz:      Intl.DateTimeFormat().resolvedOptions().timeZone,
					customer_id: customer_id,
					payload: {
						customer_orders_count: document.body.dataset.customerOrdersCount || null,
						customer_total_spent:  document.body.dataset.customerTotalSpent || null,
						customer_tags:         document.body.dataset.customerTags || null,
						viewport: window.innerWidth + 'x' + window.innerHeight
					}
				});
			}

			emit('pageview', {
				url: location.pathname,
				referrer: document.referrer || null,
				customer_id: customer_id,
				payload: { page_template: document.body.dataset.pageEvent || null }
			});

			if (customer_id && !sessionStorage.getItem('bs_identified_' + customer_id)) {
				emit('identify', {
					customer_id: customer_id,
					payload: {
						orders_count: document.body.dataset.customerOrdersCount || null,
						total_spent:  document.body.dataset.customerTotalSpent || null,
						tags:         document.body.dataset.customerTags || null
					}
				});
				sessionStorage.setItem('bs_identified_' + customer_id, '1');
			}

			// Brevo `?_se=<base64(email)>` identify — для incognito-визитов по email-рассылке.
			// Юзер не залогинен, но мы знаем его email из Brevo redirect. Лямбда резолвит
			// email → customer_id через Shopify customer.search и привязывает к visitor'у.
			var seEmail = window.__bsSeEmail;
			if (seEmail && !customer_id && !sessionStorage.getItem('bs_se_identified_' + seEmail)) {
				emit('identify', {
					payload: { email: seEmail, source: 'brevo_se' }
				});
				sessionStorage.setItem('bs_se_identified_' + seEmail, '1');
			}
		});

		// AJAX search tracking: запоминаем последний набранный query, ничего не пишем.
		var lastSearchQuery = '';
		document.addEventListener('input', function (e) {
			var el = e.target;
			if (!el || el.type !== 'search') return;
			var v = (el.value || '').trim();
			if (v.length >= 3) lastSearchQuery = v;
		}, true);

		// Click в search-результаты: эмитим search-event как сигнал успеха и через
		// sessionStorage помечаем следующее открытие /products/<handle> как via=search.
		// На destination-странице firePageloadEvent (см. bloom-session.js) подхватит
		// флаг и проставит via='search' + query в свой штатный product_view event.
		// Так не получаем дубль product_view (один с via=search, другой с via=null).
		var SEARCH_CONTAINERS = '.search-results, .js-search-results, #suggest, #searchresults, #searchinfo';
		document.addEventListener('click', function (e) {
			var anchor = e.target && e.target.closest ? e.target.closest('a[href]') : null;
			if (!anchor) return;
			var inSearch = anchor.closest(SEARCH_CONTAINERS);
			if (!inSearch) return;
			var href = anchor.getAttribute('href') || '';
			var m = href.match(/\/products\/([^/?#]+)/);
			if (!m) return;

			if (lastSearchQuery) {
				emit('search', { query: lastSearchQuery });
			}
			try {
				sessionStorage.setItem('bs_next_via', JSON.stringify({
					via:    'search',
					query:  lastSearchQuery || null,
					handle: m[1],
					expires_at: Date.now() + 30 * 1000   // флаг живёт 30 сек, дальше — устарел
				}));
			} catch (_) {}
		}, true);
	});
})();
